import React from "react";
import { Grid, Card } from "@mui/material";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import { GridRowSelectionModel } from "@mui/x-data-grid";

interface PartographTraceGridProps {
    columns: any[];
    traceRows: any[];
    rowSelectionModel: GridRowSelectionModel;
    onRowSelectionModelChange: (newSelection: GridRowSelectionModel) => void;
}

const PartographTraceGrid: React.FC<PartographTraceGridProps> = ({
    columns,
    traceRows,
    rowSelectionModel,
    onRowSelectionModelChange,
}) => {
    return (
        <Card sx={{ marginBottom: "5px", mt: "10px" }}>
            <Grid item sm={12} xs={12} md={12} xl={12} container sx={{ mt: 1 }}>
                <ByzMuiDataGrid
                    columns={columns}
                    rows={traceRows}
                    sx={{ width: "100%" }}
                    initialState={{
                        pagination: {
                            paginationModel: { pageSize: 5 },
                        },
                    }}
                    pageSizeOptions={[5, 10, 20, 50]}
                    disableColumnMenu
                    disableColumnFilter
                    disableColumnSelector
                    disableDensitySelector
                    disableMultipleRowSelection
                    checkboxSelection
                    rowSelectionModel={rowSelectionModel}
                    onRowSelectionModelChange={onRowSelectionModelChange}
                />
            </Grid>
        </Card>
    );
};

export default PartographTraceGrid;
